import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../../../services/shared';
import { AGENT_TAG_TYPES } from './tags';

/**
 * Single base RTK Query API for the Agents backend (one `createApi` per backend).
 *
 * This is intentionally EMPTY of endpoints — features inject their own endpoints via
 * `agentsApi.injectEndpoints` in `features/{x}/data/{x}Endpoints.ts`. This api owns the
 * shared concerns that must be singular for the cache to behave correctly:
 *  - the authenticated base query (auth header + agents base URL),
 *  - the single `tagTypes` registry (see `tags.ts`),
 *  - the one cache space, so request dedup and cross-feature tag invalidation work.
 *
 * Never create a second `createApi` for this backend — that would fragment the cache.
 * Import this base api by file path (`../../../data/agentsApi`) from feature endpoint files,
 * not via the `data` barrel, to avoid import cycles. The one exception is an endpoint file in
 * ANOTHER module (`financialClearance/features/agentActivity/data`), which must come through the
 * `agents/data` barrel because the file path is a private-file crossing the architecture gate
 * rejects. That is safe only while nothing in the barrel's subgraph imports back into the
 * consuming module — the barrel exports `agentsApi` on its first line, before its `export *`
 * lines, so it is live by the time a cross-module injector reads it.
 */
export const agentsApi = createApi({
  reducerPath: 'agentsApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.agents),
  tagTypes: AGENT_TAG_TYPES,
  endpoints: () => ({}),
});
